// Import stores
import AppStore from './AppStore';
import PlayerStore from './PlayerStore';
import UserStore from './UserStore';

// Combine stores
const store = {
  AppStore,
  PlayerStore,
  UserStore
};

export default store;
